import React, { useState, useEffect } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Menus = () => {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/menus/`);
      setMenus(response.data);
    } catch (error) {
      console.error('Error fetching menus:', error);
      toast.error('Failed to load menus');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMenu = async (menuId) => {
    if (!window.confirm('Are you sure you want to delete this menu?')) return;
    try {
      await axios.delete(`${API_URL}/api/menus/${menuId}`);
      toast.success('Menu deleted successfully');
      fetchMenus();
    } catch (error) {
      toast.error('Failed to delete menu');
    }
  };

  const getMenuItemsPreview = (items) => {
    if (!items || items.length === 0) return 'No items';
    const names = items.map(item => item.title).slice(0, 8);
    return names.join(', ') + (items.length > 8 ? '...' : '');
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold">Menus</h1>
            <p className="text-gray-500 mt-1">Manage navigation menus for your store</p>
        </div>
        <Button onClick={() => navigate('/menus/new')}>
          Create menu
        </Button>
      </div>

      {loading ? (
        <div className="text-center py-12">Loading menus...</div>
      ) : menus.length === 0 ? (
        <Card>
          <CardContent className="text-center py-12">
            <p className="text-gray-500 mb-4">No menus found. Create your first menu to get started!</p>
            <Button onClick={() => navigate('/menus/new')}>
              Create menu
            </Button>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <div className="divide-y">
            <div className="grid grid-cols-12 gap-4 p-4 bg-gray-50 text-sm font-medium text-gray-600">
              <div className="col-span-3">Menu</div>
              <div className="col-span-8">Menu items</div>
              <div className="col-span-1"></div>
            </div>
            
            {menus.map((menu) => (
              <div 
                key={menu.id} 
                className="grid grid-cols-12 gap-4 p-4 hover:bg-gray-50 items-center"
              >
                <div 
                  className="col-span-3 cursor-pointer font-medium"
                  onClick={() => navigate(`/menus/${menu.id}`)}
                >
                  {menu.name}
                </div>
                <div className="col-span-8 text-sm text-gray-600 truncate">
                  {getMenuItemsPreview(menu.items)}
                </div>
                <div className="col-span-1 flex justify-end">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteMenu(menu.id);
                    }}
                  >
                    <Trash2 className="h-4 w-4 text-red-600" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
      </div>
    </DashboardLayout>
  );
};

export default Menus;
